@if (!isReady()) {
  <div class="flex items-center justify-center h-screen">
    <h2>Cargando datos...</h2>
  </div>
} @else if (screenLock.locked()) {
  <!-- Overlay que bloquea -->
  <div class="screen-overlay-lock"></div>
  <!-- Modal de login para autorizaciones-->
  <app-login-modal-autorice> </app-login-modal-autorice>
} @else if (!screenLock.locked() && userBackend()){
<div class="page-gradient">
  <div class="device-register">

    <p-card class="title-card card-custom">
      <h2 class="font-bold text-2xl dark:text-surface-500">Registro de Equipo</h2>
      <div class="flex flex-col">
        <span class="font-bold dark:text-surface-500">{{ userBackend()?.nombre | uppercase  }} - {{ userBackend()?.descripcion }}</span>
        <span class="text-xs font-medium text-surface-500 dark:text-surface-500">{{ deviceId }}</span>
      </div>
    </p-card>
    <!-- OPCIONES POR PAIS -->
    <p-card class="section-card">
      <h3 class="font-bold">Opciones por país</h3>

      <p-pickList
        [source]="disponibles()"
        [target]="seleccionados()"
        metaKeySelection="true"
        sourceHeader="Disponibles"
        targetHeader="Seleccionados"
        [dragdrop]="!isMobile()"
        responsive="true"
        [showSourceControls]="false"
        [showTargetControls]="false"
        styleClass="picklist"
        (onMoveToSource)="onMoveToSource($event)"
        (onTargetSelect)="onTargetSelect($event)"
        >
        <ng-template let-item #item>
          <span [class.selected-default]="seleccionado()?.pais === item.pais">
            <b>{{ item.pais }}</b> - {{ item.descripcion }}
          </span>
        </ng-template>
      </p-pickList>


      <div class="form-row mt-4">
        <label for="puntoVenta" class="dark:text-surface-500">Punto Venta:</label>
        <p-select
          inputId="puntoVenta"
          #pSelect
          id="pSelect"
          [options]="puntosVenta()"
          [(ngModel)]="puntoVentaSeleccionado"
          (onChange)="onChange()"
          optionLabel="descripcion"
          placeholder="Seleccione un Punto de Venta"
          [filter]="true"
          filterBy="puntoVenta,descripcion"
          [showClear]="true"
          appendTo="body"
          [virtualScroll]="true"
          [virtualScrollItemSize]="44"
          scrollHeight="250px"
          (onShow)="onShowPvSelect()"
          size="small">
          <!-- Item del dropdown -->
          <ng-template pTemplate="item" let-item>
            <span>
              <b>{{ seleccionado()?.pais }}-{{ item.puntoVenta }}</b> - {{ item.descripcion }}
            </span>
          </ng-template>
          <!-- Item seleccionado -->
          <ng-template pTemplate="selectedItem" let-item>
            @if (item) {
              <span>
                <b>{{ seleccionado()?.pais }}-{{ item.puntoVenta }}</b> - {{ item.descripcion }}
              </span>
            } @else {
              <span class="p-text-secondary">
                Seleccione un Punto de Venta
              </span>
            }
          </ng-template>
        </p-select>

        <div class="checkbox-inline">
          <p-checkbox
            inputId="pvDefault"
            [(ngModel)]="pvDefault"
            binary="true"
            size="small">
          </p-checkbox>
          <label for="pvDefault" class="dark:text-surface-500">PV predeterminado</label>
        </div>
      </div>
    </p-card>

    <!-- OPCIONES DE EQUIPO -->
<!--    Se oculta de momento , ya que no se va a ocupar, pero se siguen enviando lso datos al backend -->
<!--    <p-card class="section-card">-->
<!--      <h3 class="font-bold">Opciones de equipo</h3>-->

<!--      <div class="options-row">-->
<!--        <p-checkbox inputId="multiplesSesiones" [(ngModel)]="multiplesSesiones" binary="true"></p-checkbox>-->
<!--        <label for="multiplesSesiones" class="dark:text-surface-500">Múltiples Sesiones</label>-->

<!--        <p-checkbox inputId="cambiarPV" [(ngModel)]="cambiarPV" binary="true"></p-checkbox>-->
<!--        <label for="cambiarPV" class="dark:text-surface-500">Cambiar Punto de Venta</label>-->

<!--        <p-checkbox inputId="nuevaPantalla" [(ngModel)]="nuevaPantalla" binary="true"></p-checkbox>-->
<!--        <label for="nuevaPantalla" class="dark:text-surface-500">Nueva Pantalla Captura</label>-->
<!--      </div>-->
<!--    </p-card>-->

    <!-- IMPRESORAS -->
  <!--    Se oculta de momento , ya que no se va a ocupar, pero se siguen enviando lso datos al backend -->

    <!--    <p-card class="section-card">-->
<!--      <h3 class="font-bold">Impresoras</h3>-->

<!--      <div class="printer-grid">-->

<!--        <div class="printer-item">-->
<!--          <label for="printerStore" class="dark:text-surface-500">Tienda:</label>-->
<!--          <input pInputText [(ngModel)]="printerStore" pSize="small" />-->
<!--          <p-checkbox inputId="printerStore" [(ngModel)]="printerStoreWeb" binary="true" size="small"></p-checkbox>-->
<!--          <span >WEB</span>-->
<!--        </div>-->

<!--        <div class="printer-item">-->
<!--          <label for="printerZebraWeb" class="dark:text-surface-500">Zebra:</label>-->
<!--          <input pInputText [(ngModel)]="printerZebra" pSize="small" />-->
<!--          <p-checkbox inputId="printerZebraWeb" [(ngModel)]="printerZebraWeb" binary="true" size="small"></p-checkbox>-->
<!--          <span>WEB</span>-->
<!--        </div>-->

<!--        <div class="printer-item">-->
<!--          <label for="almacen" class="dark:text-surface-500">Almacén:</label>-->
<!--          <input id="almacen" [(ngModel)]="printerAlmacen"  pInputText pSize="small" />-->
<!--        </div>-->

<!--      </div>-->
<!--    </p-card>-->

    <!-- ACCIONES -->
    <div class="actions">
      @if (!edit) {
        <p-button  [label]="buttonLabel" severity="primary" (click)="save()" ></p-button>
      } @else {
      <p-button  [label]="buttonLabel" severity="primary" (click)="update()" ></p-button>

      }

      <p-button  label="Limpiar" severity="info" (click)="clean()" ></p-button>
      <p-button  label="Cancelar" severity="danger" (click)="nav(false)" ></p-button>
    </div>

  </div>
</div>

}
